var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtlftbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 201,
    viewBox: "0 0 143 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-64.6494 26.4265C-85.1534 38.7045 -100.288 56.3865 -109.393 76.4985C-110.654 79.2879 -113.49 81.0284 -116.55 80.8099L-116.735 80.798C-122.082 80.4181 -125.207 74.5589 -122.481 69.9557C-111.304 51.087 -95.5719 34.5208 -75.6745 22.0506C-10.009 -19.1008 77.4173 0.101878 119.554 64.9686C151.299 113.834 149.018 174.682 118.946 220.219C110.546 232.938 92.2323 234.081 82.136 222.664C74.6233 214.169 74.4495 201.574 81.527 192.709C110.908 155.912 115.037 103.006 87.6872 61.26C54.722 10.9491 -12.9467 -4.53216 -64.6494 26.4265Z",
    fill: "#E2B44B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtlftbg);
export default __webpack_public_path__ + "static/media/btlftbg.d0ef1b8e2bde1cc75b1e5a715c5c8aee.svg";
export { ForwardRef as ReactComponent };